import React, { useState } from "react";
import reviews from "../../constants";

import "./CustomerReview.scss";
import Pagination from "../../common/components/Pagination";
import ReviewCard from "./ReviewCard";
import VideoModal from "../../common/components/VideoModal";

const CustomerReviewForm = () => {
  const PAGE_SIZE = 10;

  const [page, setPage] = useState(1);
  const [selectedVideo, setSelectedVideo] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const startIndex = (page - 1) * PAGE_SIZE;

  const currentReviews = reviews.slice(
    startIndex,
    startIndex + PAGE_SIZE
  );

  const handleVideoClick = (url) => {
    setSelectedVideo(url);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedVideo("");
  };

  return (
    <div className="review-wrapper">
      <div className="review-grid">
        {currentReviews.map((item) => (
          <ReviewCard
            key={item.id}
            review={item}
            onVideoClick={handleVideoClick}
          />
        ))}
      </div>

      <Pagination
        page={page}
        pageSize={PAGE_SIZE}
        total={reviews.length}
        onChange={setPage}
      />

      <VideoModal
        isOpen={isModalOpen}
        videoUrl={selectedVideo}
        onClose={closeModal}
      />
    </div>
  );
};

export default CustomerReviewForm;